import template from './slot.html'
import './slot.css'

export default {
  template,
  controller: function () { },
  controllerAs: 'slot',
  bindings: { data: '=', position: '=' }
}
